<template>
    <div class="board_content">
        <div class="summary">
            <div style="margin-left:5px;font-weight: bold;">{{ $t('dataBoard.dataStatistics') }}</div> 
            <div class="summary_data">
                <div class="block block_blue">
                    <div class="block_left">
                        <div class="title">{{ $t('dataBoard.orderQuantity') }}</div>
                        <div class="num">{{ dataCount.orderCount }}</div>
                    </div>
                    <div class="block_right">
                        <img class="img" src="@/assets/image/chart_bg4.jpg" alt="">
                    </div>
                </div>
                <div class="block block_green">
                    <div class="block_left">
                        <div class="title">{{ $t('dataBoard.bikeQuantity') }}</div>
                    <div class="num">{{ dataCount.bikeCount }}</div>
                    </div>
                    <div class="block_right">
                        <img class="img" src="@/assets/image/chart_bg1.jpg" alt="">
                    </div>
                </div>
                <div class="block block_blue">
                    <div class="block_left">
                        <div class="title">{{ $t('dataBoard.returnQuantity') }}</div>
                        <div class="num">{{ dataCount.recordCount }}</div>
                    </div>
                    <div class="block_right">
                        <img class="img" src="@/assets/image/chart_bg2.jpg" alt="">
                    </div>
                </div>
                <div class="block block_purple">
                    <div class="block_left">
                        <div class="title">{{ $t('dataBoard.shipmentQuantity') }}</div>
                        <div class="num">{{ dataCount.stockOutCount }}</div>
                    </div>
                    <div class="block_right">
                        <img class="img img3" src="@/assets/image/chart_bg5.jpg" alt="">
                    </div>
                </div>
                <div class="block block_blue">
                    <div class="block_left">
                        <div class="title">{{ $t('dataBoard.cancelQuantity') }}</div>
                        <div class="num">{{ dataCount.cancelCount }}</div>
                    </div>
                    <div class="block_right">
                        <img class="img" src="@/assets/image/chart_bg2.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="summary2">
            <div style="margin-left:5px;font-weight: bold;">{{ $t('dataBoard.paymentStatistics') }}</div> 
            <div class="summary_data2">
                <div class="block">
                    <div class="block_left">
                        <icon-send :size="25" class="block_left_icon1"/>
                    </div>
                    <div class="block_right">
                        <div class="title">{{ $t('dataBoard.paidButUnshippedBike') }}</div>
                        <div class="num">{{ dataCount.payUnshipCount }}</div>
                    </div>
                </div>
                <div class="block">
                    <div class="block_left">
                        <icon-bookmark :size="25" class="block_left_icon2"/>
                    </div>
                    <div class="block_right">
                        <div class="title">{{ $t('dataBoard.fullRefundBike') }}</div>
                        <div class="num">{{ dataCount.refundCount }}</div>
                    </div>
                </div>
                <div class="block">
                    <div class="block_left">
                        <icon-command :size="25" class="block_left_icon3"/>
                    </div>
                    <div class="block_right">
                        <div class="title">{{ $t('dataBoard.pendingPayBike') }}</div>
                        <div class="num">{{ dataCount.pendingPayCount }}</div>
                    </div>
                </div>
                <div class="block">
                    <div class="block_left">
                        <icon-subscribed :size="25" class="block_left_icon4"/>
                    </div>
                    <div class="block_right">
                        <div class="title">
                            {{ $t('dataBoard.overdueAndUnpaidBike') }}
                            <a-popover position="left">
                                <icon-question-circle :size="20" style="vertical-align: bottom;cursor:pointer"/>
                                <template #content>
                                    <div>{{$t('dataBoard.overdueDay')}}</div>
                                </template>
                            </a-popover>
                        </div>
                        <div class="num">{{ dataCount.overdueCount }} </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="summary3">
            <div class="block block1">
                <div class="popover_search_btn">
                    <a-popover class="popover_search" :popup-visible="popupVisible1" position="bl" trigger="click" popup-container="HTMLElement">
                        <a-button type="text" @click="search('form1')">{{ $t('base.filter') }} <icon-filter style="margin-left: 5px;"/></a-button>
                        <template #content>
                            <Form :form="queryForm" class="popover_query"></Form>
                            <div class="queryFormBtn" style="text-align:right;">
                                <a-button type="primary" @click="confirm('queryForm1')">{{ $t('dataBoard.confirm') }}</a-button>
                                <a-button style="margin-left: 10px;" @click="cancel('queryForm1')">{{ $t('base.cancel') }}</a-button>
                            </div>
                        </template>
                    </a-popover>
                    <!-- <span style="margin-left: 10px;font-size: 12px;color: #ccc;">{{ $t('dataBoard.past7days') }}</span> -->
                    <span style="margin-left: 10px;font-size: 12px;color: #ccc;">{{ $t('order.orderDate') }}：{{ searchDate1 }}</span>
                </div>
                <div class="block_count">
                    <div class="block_count_content">
                        <div class="block_count_row">
                            <span class="title">{{ $t('dataBoard.orderQuantity') }}</span>
                            <span class="num">{{ dataCount.orderCount_select }}</span>
                        </div>
                        <div class="block_count_row">
                            <span class="title">{{ $t('dataBoard.bikeQuantity') }}</span>
                            <span class="num">{{ dataCount.bikeCount_select }}</span>
                        </div>
                    </div>
                    <div class="block_count_content">
                        <div class="block_count_row">
                            <span class="title">{{ $t('dataBoard.paidButUnshippedBike') }}</span>
                            <span class="num">{{ dataCount.payUnshipCount_select }}</span>
                        </div>
                        <div class="block_count_row">
                            <span class="title">{{ $t('dataBoard.pendingPayBike') }}</span>
                            <span class="num">{{ dataCount.pendingPayCount_select }}</span>
                        </div>
                    </div>
                </div>
            </div> 

            <div class="block block2">
                <div class="popover_search_btn">
                    <a-popover class="popover_search" :popup-visible="popupVisible2" position="bl" trigger="click" popup-container="HTMLElement">
                        <a-button type="text" @click="search('form2')">{{ $t('base.filter') }} <icon-filter style="margin-left: 5px;"/></a-button>
                        <template #content>
                            <Form :form="queryForm2" class="popover_query"></Form>
                            <div class="queryFormBtn" style="text-align:right;">
                                <a-button type="primary" @click="confirm('queryForm2')">{{ $t('dataBoard.confirm') }}</a-button>
                                <a-button style="margin-left: 10px;" @click="cancel('queryForm2')">{{ $t('base.cancel') }}</a-button>
                            </div>
                        </template>
                    </a-popover>
                    <!-- <span style="margin-left: 10px;font-size: 12px;color: #ccc;">{{ $t('dataBoard.past7days') }}</span> -->
                    <span style="margin-left: 10px;font-size: 12px;color: #ccc;">{{ $t('dataBoard.realShipDate') }}：{{ searchDate2 }}</span>
                </div>
                <div class="block_count">
                    <div class="block_count_row">
                        <span class="title">{{ $t('dataBoard.outboundBike') }}</span>
                        <span class="num">{{ dataCount.shipCount_select }}</span>
                        <img class="img" src="@/assets/image/chart_bg8.jpg" alt="">
                    </div>
                </div>
            </div> 

            <div class="block block3">
                <div class="block_head">
                    <span class="head">
                        <div>{{ $t('dataBoard.timelyDeliveryRate') }}</div>
                        <!-- <div style="font-weight: normal;font-size: 11px;color: #ccc;transform: scale(.9);margin-left: -22px;">{{ $t('dataBoard.past7days') }}</div> -->
                        <span style="font-size: 12px;font-weight:normal;color: #ccc;">{{ $t('order.orderDate') }}：{{ searchDate3 }}</span>
                    </span>
                    <a-button type="default" @click="exportFile"><icon-to-bottom /></a-button>
                    <div class="popover_search_btn">
                        <a-popover class="popover_search" :popup-visible="popupVisible3" position="br" trigger="click" popup-container="HTMLElement">
                            <a-button type="text" @click="search('form3')">{{ $t('base.filter') }} <icon-filter style="margin-left: 5px;"/></a-button>
                            <template #content>
                                <Form :form="queryForm3" class="popover_query"></Form>
                                <div class="queryFormBtn" style="text-align:right;">
                                    <a-button type="primary" @click="confirm('queryForm3')">{{ $t('dataBoard.confirm') }}</a-button>
                                    <a-button style="margin-left: 10px;" @click="cancel('queryForm3')">{{ $t('base.cancel') }}</a-button>
                                </div>
                            </template>
                        </a-popover>
                    </div>
                </div>
                <div class="block_count">
                    <div class="block_count_row">
                        <div id="chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { DashboardApi } from '@/api/DashboardApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Form from '@/components/Form.vue';
    import { QueryForm, QueryForm2, QueryForm3 } from './queryConfig/QueryForm.js';
    import { dateToTimestamp, timestampToDate, getNowDate, getPrev7Date } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import * as echarts from 'echarts'

    const { t } = useI18n()

    const BASE_URL = import.meta.env.VITE_BASE_URL

    const dataCount = reactive({
        orderCount:0,
        bikeCount:0,
        recordCount:0,
        payUnshipCount:0,
        refundCount:0,
        cancelCount:0,
        pendingPayCount:0,
        stockOutCount:0,
        overdueCount:0,
        shipCount:0,
        deliveryCount:0,

        orderCount_select:0,
        bikeCount_select:0,
        payUnshipCount_select:0,
        pendingPayCount_select:0,
        shipCount_select:0,

        totalEBike:0,
        within3:0,
        within7:0,
        over7:0,
        no_stock_out:0,
    })

    const searchDate1 = ref('')
    const searchDate2 = ref('')
    const searchDate3 = ref('')

    const popupVisible1 = ref(false)
    const popupVisible2 = ref(false)
    const popupVisible3 = ref(false)

    const queryForm = reactive(QueryForm)
    const queryForm2 = reactive(QueryForm2)
    const queryForm3 = reactive(QueryForm3)

    const init = ()=>{
        queryForm.formData.order_date = [getPrev7Date(), getNowDate()]
        queryForm2.formData.real_ship_date = [getPrev7Date(), getNowDate()]
        queryForm3.formData.order_date = [getPrev7Date(), getNowDate()]

        searchDate1.value = `${getPrev7Date()}~${getNowDate()}`
        searchDate2.value = `${getPrev7Date()}~${getNowDate()}`
        searchDate3.value = `${getPrev7Date()}~${getNowDate()}`
    }

    // 点击筛选
    const search = (type)=>{
        switch(type){
            case 'form1':
                popupVisible1.value = true
                break;
            case 'form2':
                popupVisible2.value = true
                break;
            case 'form3':
                popupVisible3.value = true
                break;
        }
    }

    // 导出交付率明细
    const exportFile = async ()=>{
        let param = {
            order_begin_time:!queryForm3.formData.order_date? '' : dateToTimestamp(`${queryForm3.formData.order_date[0]} 00:00:00`),
            order_end_time: !queryForm3.formData.order_date? '' : dateToTimestamp(`${queryForm3.formData.order_date[1]} 23:59:59`),
            ship_begin_time: !queryForm3.formData.ship_date || queryForm3.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm3.formData.ship_date[0]} 00:00:00`),
            ship_end_time: !queryForm3.formData.ship_date || queryForm3.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm3.formData.ship_date[1]} 23:59:59`),
            status:2,
            category:'627.501',
            warehouse: queryForm3.formData.warehouse,
            order_type:0,
        }
        let res = await DashboardApi.getInstance().export(param)
        if(res){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('dataBoard.deliveryRateDetails')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
        }
    }
    

    // 搜索确认
    const confirm = (type)=>{
        if(type == 'queryForm1'){
            if(queryForm.formData.source.length > 0 && queryForm.formData.source[0] == '') queryForm.formData.source.shift()
            if(queryForm.formData.order_status.length > 0 && queryForm.formData.order_status[0] == '') queryForm.formData.order_status.shift()
            if(queryForm.formData.courier_status.length > 0 && queryForm.formData.courier_status[0] == '') queryForm.formData.courier_status.shift()
            getOrderCountSelect()
            getBikeCountSelect()
            getPayUnshipCountSelect()
            getPendingPayCountSelect()

            searchDate1.value = `${queryForm.formData.order_date[0]}~${queryForm.formData.order_date[1]}`
        }

        if(type == 'queryForm2'){
            if(queryForm2.formData.source.length > 0 && queryForm2.formData.source[0] == '') queryForm2.formData.source.shift()
            if(queryForm2.formData.order_status.length > 0 && queryForm2.formData.order_status[0] == '') queryForm2.formData.order_status.shift()
            getShipCountSelect()

            searchDate2.value = `${queryForm2.formData.real_ship_date[0]}~${queryForm2.formData.real_ship_date[1]}`
        }

        if(type == 'queryForm3'){
            if(!queryForm3.formData.order_date){
                Message.error(t('order.orderDate') +' '+ t('base.noEmpty'))
                return 
            }
            getDeliveryCount()

            searchDate3.value = `${queryForm3.formData.order_date[0]}~${queryForm3.formData.order_date[1]}`
        }
        
    }

    const cancel = (type)=>{
        if(type == 'queryForm1'){
            queryForm.formField.forEach(i=>{
                if(i.key !== 'order_date'){
                    queryForm.formData[i.key] = ''
                }
            })
            popupVisible1.value = false
            queryForm.formData.order_date = [getPrev7Date(), getNowDate()]
            searchDate1.value = `${getPrev7Date()}~${getNowDate()}`
            getOrderCountSelect()
            getBikeCountSelect()
            getPayUnshipCountSelect()
            getPendingPayCountSelect()
        }

        if(type == 'queryForm2'){
            queryForm2.formField.forEach(i=>{
                if(i.key !== 'order_date' && i.key !== 'ship_date' && i.key !== 'real_ship_date'){
                    queryForm2.formData[i.key] = ''
                }
                queryForm2.formData.ship_date = []
                queryForm2.formData.real_ship_date = []
            })
            popupVisible2.value = false
            queryForm2.formData.real_ship_date = [getPrev7Date(), getNowDate()]
            searchDate2.value = `${getPrev7Date()}~${getNowDate()}`
            getShipCountSelect()
        }

        if(type == 'queryForm3'){
            queryForm3.formField.forEach(i=>{
                if(i.key !== 'order_date' && i.key !== 'ship_date'){
                    queryForm3.formData[i.key] = ''
                }
                queryForm3.formData.ship_date = []
            })
            popupVisible3.value = false
            queryForm3.formData.order_date = [getPrev7Date(), getNowDate()]
            searchDate3.value = `${getPrev7Date()}~${getNowDate()}`
            getDeliveryCount()
        }
        
    }

    // 获取订单总数-筛选
    const getOrderCountSelect = async ()=>{
        console.log(queryForm.formData.order_date,'bbb')
        let param = {
            order_channel_type: queryForm.formData.order_channel_type,
            order_begin_time: queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`),
            order_end_time:  queryForm.formData.order_date == undefined? '' :  dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`),
            order_type:0,
        }
        if(queryForm.formData.source.length > 0) param.source = queryForm.formData.source
        if(queryForm.formData.order_status.length > 0) param.order_status = queryForm.formData.order_status
        if(queryForm.formData.courier_status.length > 0) param.courier_status = queryForm.formData.courier_status
        // console.log(param,'param')

        let res = await DashboardApi.getInstance().getOrderCount(param)
        if(res.code == 0){
            dataCount.orderCount_select = res.data
            popupVisible1.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车数量-筛选
    const getBikeCountSelect = async ()=>{
        let param = {
            order_channel_type: queryForm.formData.order_channel_type,
            order_begin_time: queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`),
            order_end_time:  queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`),
            order_type:0,
        }
        if(queryForm.formData.source.length > 0) param.source = queryForm.formData.source
        if(queryForm.formData.order_status.length > 0) param.order_status = queryForm.formData.order_status
        if(queryForm.formData.courier_status.length > 0) param.courier_status = queryForm.formData.courier_status
        // console.log(param,'param')

        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.bikeCount_select = res.data
            popupVisible1.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车已付款未发货数量-筛选
    const getPayUnshipCountSelect = async ()=>{
        let param = {
            order_channel_type: queryForm.formData.order_channel_type,
            order_status: [1],
            courier_status: [0],
            order_begin_time: queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`),
            order_end_time:  queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`),
            order_type:0,
        }
        if(queryForm.formData.source.length > 0) param.source = queryForm.formData.source
        // console.log(param,'param')

        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.payUnshipCount_select = res.data
            popupVisible1.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车未付款未发货数量-筛选
    const getPendingPayCountSelect = async ()=>{
        let param = {
            order_channel_type: queryForm.formData.order_channel_type,
            order_status: [7],
            courier_status: [0],
            order_begin_time: queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`),
            order_end_time: queryForm.formData.order_date == undefined? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`),
            order_type:0,
        }
        if(queryForm.formData.source.length > 0) param.source = queryForm.formData.source
        // console.log(param,'param')

        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.pendingPayCount_select = res.data
            popupVisible1.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取已出库整车数量-筛选
    const getShipCountSelect = async ()=>{
        console.log(queryForm2.formData,'hhh')
        let param = {
            order_channel_type: queryForm2.formData.order_channel_type,
            warehouse: queryForm2.formData.warehouse,
            stock_out_status:2,
            order_begin_time: !queryForm2.formData.order_date? '' : dateToTimestamp(`${queryForm2.formData.order_date[0]} 00:00:00`),
            order_end_time: !queryForm2.formData.order_date? '' : dateToTimestamp(`${queryForm2.formData.order_date[1]} 23:59:59`),
            ship_begin_time: !queryForm2.formData.ship_date || queryForm2.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm2.formData.ship_date[0]} 00:00:00`),
            ship_end_time: !queryForm2.formData.ship_date || queryForm2.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm2.formData.ship_date[1]} 23:59:59`),
            real_begin_time: !queryForm2.formData.real_ship_date || queryForm2.formData.real_ship_date.length == 0? '' : dateToTimestamp(`${queryForm2.formData.real_ship_date[0]} 00:00:00`),
            real_end_time: !queryForm2.formData.real_ship_date || queryForm2.formData.real_ship_date.length == 0? '' : dateToTimestamp(`${queryForm2.formData.real_ship_date[1]} 23:59:59`),
            order_type:0,
        }
        if(queryForm2.formData.source.length > 0) param.source = queryForm2.formData.source
        if(queryForm2.formData.order_status.length > 0) param.order_status = queryForm2.formData.order_status
        // console.log(param,'param')

        let res = await DashboardApi.getInstance().getShipCount(param)
        if(res.code == 0){
            dataCount.shipCount_select = res.data
            popupVisible2.value = false
        }else{
            Message.error(res.msg)
        }
    }


    // 获取订单总数
    const getOrderCount = async ()=>{
        let param = {
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getOrderCount(param)
        if(res.code == 0){
            dataCount.orderCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车销量
    const getBikeCount = async ()=>{
        let param = {
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getBikeCount(param)
        if(res.code == 0){
            dataCount.bikeCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车退货数量
    const getRecordCount = async ()=>{
        let param = {
            type:1, // 退货
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getRecordCount(param)
        if(res.code == 0){
            dataCount.recordCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车已付款未发货数量  订单状态： 1=支付  2=退款  6=取消 7=未付款    发货状态： 0=未发货  
    const getPayUnshipCount = async ()=>{
        let param = {
            "order_status": [1],
            "courier_status": [0],
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.payUnshipCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车全额退款数量  订单状态： 1=支付  2=退款  6=取消 7=未付款    发货状态： 0=未发货  
    const getRefundCount = async ()=>{
        let param = {
            "order_status": [2],
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.refundCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车取消数量  订单状态： 1=支付  2=退款  6=取消 7=未付款    发货状态： 0=未发货  
    const getCancelCount = async ()=>{
        let param = {
            "order_status": [6],
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getHeadCount(param)
        if(res.code == 0){
            dataCount.cancelCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车未付款未发货数量  订单状态： 1=支付  2=退款  6=取消  7=未付款    发货状态： 0=未发货  
    const getPendingPayCount = async ()=>{
        let param = {
            "order_status": [7],
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getNoPaidShipCount(param)
        if(res.code == 0){
            dataCount.pendingPayCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取整车发货数量
    const getStockOutCount = async ()=>{
        let param = {
            category:'627.501',
            status:2,
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getStockOutCount(param)
        if(res.code == 0){
            dataCount.stockOutCount = res.data
        }else{
            Message.error(res.msg)
        }
    }


    // 获取整车超期未付款未发货数量   订单状态： 1=支付  2=退款  6=取消  7=未付款    发货状态： 0=未发货  
    const getOverdueCount = async ()=>{
        let param = {
            "order_status": [7],
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getOverdueCount(param)
        if(res.code == 0){
            dataCount.overdueCount = res.data
        }else{
            Message.error(res.msg)
        }
    }

    // 获取已出库整车数量
    // const getShipCount = async ()=>{
    //     let res = await DashboardApi.getInstance().getShipCount({})
    //     if(res.code == 0){
    //         dataCount.shipCount = res.data
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 获取及时交付率
    const getDeliveryCount = async ()=>{
        let param = {
            order_begin_time:!queryForm3.formData.order_date? '' : dateToTimestamp(`${queryForm3.formData.order_date[0]} 00:00:00`),
            order_end_time:!queryForm3.formData.order_date? '' : dateToTimestamp(`${queryForm3.formData.order_date[1]} 23:59:59`),
            ship_begin_time: !queryForm3.formData.ship_date || queryForm3.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm3.formData.ship_date[0]} 00:00:00`),
            ship_end_time:!queryForm3.formData.ship_date || queryForm3.formData.ship_date.length == 0? '' : dateToTimestamp(`${queryForm3.formData.ship_date[1]} 23:59:59`),
            status:2,
            category:'627.501',
            warehouse:queryForm3.formData.warehouse,
            order_type:0,
        }
        let res = await DashboardApi.getInstance().getDeliveryCount(param)
        if(res.code == 0){
            popupVisible3.value = false

            dataCount.totalEBike = res.data.total
            dataCount.within3 = res.data.day3 || 0
            dataCount.within7 = res.data.day7 || 0
            dataCount.over7 = res.data.dayOther 
            dataCount.no_stock_out = res.data.no_stock_out || 0
            console.log(dataCount.over7,'dataCount.over7')

            renderChart()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await DashboardApi.getInstance().getWarehouse()
        if(res.code == 0){
            let item1 = queryForm2.formField.find(i=> i.key == 'warehouse')
            let item2 = queryForm3.formField.find(i=> i.key == 'warehouse')
            item1.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item1.options.push({
                    label: i.description, 
                    value: i.subinventory_name,
                })
                item2.options.push({
                    label: i.description, 
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await DashboardApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'source')
            let item2 = queryForm2.formField.find(i=> i.key == 'source')
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型 
                    code: i.customer_number, // erp客户编码
                })
                item2.options.push({
                    label:i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型 
                    code: i.customer_number, // erp客户编码
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 图表 3天内
    const renderChart = ()=> {
        nextTick(() => {
            let myChart = echarts.init(document.getElementById('chart'))
            myChart.clear()

            window.addEventListener("resize", () => {
                myChart.resize();
            });
           
            let option = {
                color:['#86de6d','#498df9','#713bdb','#ff4500'],
                legend: {
                    top: '2%',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,  
                        },
                        emphasis: {
                            label: {
                            show: true,
                            fontSize: 20,
                            fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: [
                            {
                                value: dataCount.within3,
                                name: t('dataBoard.within3'),
                                label:{
                                    normal:{ 
                                        show:true,
                                        formatter: '{d}%',
                                        textStyle: {
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                        },
                                    }
                                }
                            },
                            {
                                value: dataCount.within7,
                                name: t('dataBoard.within7'),
                                label:{
                                    normal:{ 
                                        show:true,
                                        formatter: '{d}%',
                                        textStyle: {
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                        },
                                    }
                                }
                            },
                            {
                                value: dataCount.over7,
                                name: t('dataBoard.over7'),
                                label:{
                                    normal:{ 
                                        show:true,
                                        formatter: '{d}%',
                                        textStyle: {
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                        },
                                    }
                                }
                            },
                            {
                                value: dataCount.no_stock_out,
                                name: t('dataBoard.unscheduledOrder'),
                                label:{
                                    normal:{ 
                                        show:true,
                                        formatter: '{d}%',
                                        textStyle: {
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                        },
                                    }
                                }
                            },
                        ]
                    }
                ]
            };

            myChart.setOption(option);
      
        })
    }

    onMounted(async()=>{
        getOrderCount()
        getBikeCount()
        getRecordCount()
        
        getPayUnshipCount()
        getRefundCount()
        getCancelCount()
        getPendingPayCount()

        getStockOutCount()
        getOverdueCount()

        getWarehouse()
        getOrderSource()

        await init()
        getOrderCountSelect()
        getBikeCountSelect()
        getPayUnshipCountSelect()
        getPendingPayCountSelect()
        getShipCountSelect()
        await getDeliveryCount()
    })

</script>

<style lang="less" scoped>
.board_content{
    padding-bottom: 50px;
}
.summary{
    padding: 20px 15px;
    background: #fff;

    .summary_data{
        display: flex;
        margin-top: 10px;
        .block{
            display: flex;
            flex: 1;
            padding: 15px;
            margin: 0 5px;

            .block_left{
                display: flex;
                flex: 1;
                flex-direction: column;
                .title{
                    margin-bottom: 5px;
                    font-size: 14px;
                    font-weight: 700;
                    color: #666;
                }

                .num{
                    font-size: 22px;
                    font-weight: 500;
                }
            }
            

            .block_right{
                display: flex;
                flex: 1;
                .img{
                    display: inline-block;
                    float: right;
                    margin-top: 15px;
                    // margin-left: 10px;
                    width: 100%;
                }

                .img3{
                    width: 100px;
                    // height: 180px;
                }
            }

        }

        .block_blue{
            background: linear-gradient(rgb(242, 249, 254) 0%, rgb(230, 244, 254) 100%);
        }

        .block_green{
            background: linear-gradient(rgb(245, 254, 242) 0%, rgb(230, 254, 238) 100%);
        }

        .block_purple{
            background: linear-gradient(rgb(247, 247, 255) 0%, rgb(236, 236, 255) 100%);
        }
    }
    
}

.summary2{
    margin-top: 10px;
    padding: 15px;
    background: #fff;

    .summary_data2{
        display: flex;
        margin-top: 15px;
        padding: 20px 0;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;

        .block{
            display: flex;
            flex: 1;
            padding: 5px 15px;
            margin: 0 5px;
            border-right: 1px solid #eee;
            

            .block_left{
                display: flex;
                margin-right: 15px;
                align-items: center;
                padding:22px;
                border-radius: 50%;
                background: #f2f3f5;
                

                /deep/ .block_left_icon1.arco-icon{
                    color: #7897f9;
                }
                /deep/ .block_left_icon2.arco-icon{
                    color: #db76fe;
                }
                /deep/ .block_left_icon3.arco-icon{
                    color: #fca375;
                }
                /deep/ .block_left_icon4.arco-icon{
                    color: #32b3f6;
                }
            }

            .block_right{
                display: flex;
                // flex: 1;
                flex-direction: column;

                .title{
                    margin-bottom: 5px;
                    font-size: 14px;
                    // font-weight: 700;
                    color: #666;
                }

                .num{
                    font-size: 26px;
                    font-weight: 500;
                }
            }
        }

        .block:nth-last-child(1){
           border-right: none;
        }
    }
}

.summary3{
    display: flex;
    margin-top: 10px;

    .block{
        margin-right: 10px;
        padding: 15px;
        background:#fff;
    }
    .block:nth-last-child(1){
        margin-right: 0;
    }

    .block1{
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-right: 10px;
        padding: 15px;
        background:#fff;

        .block_count{
            display: flex;
            flex:1;
            flex-direction: column;

            .block_count_content{
                display: flex;
                flex:1;
                padding: 37px 10px;
                border-bottom: 1px solid #eee;

                .block_count_row{
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid #eee;

                    .title{
                        font-size: 13px;
                        color: #333;
                        font-weight: 500;
                        
                    }

                    .num{
                        font-size: 26px;
                        font-weight: 500px;
                        color: #5470c6;
                    }

                    .img{
                        width:70%;
                        text-align: center;
                        justify-content: center;
                        margin-left: 50px;
                    }
                }

                .block_count_row:nth-last-child(1){
                    border-right: none;
                }
            }

            .block_count_content:nth-last-child(1){
                border-bottom: none;
            }
            
        }
    }

    .block2{
        display: flex;
        flex: 1;
        flex-direction: column;
        .block_count_row{
            display:flex;
            flex-direction: column;
            padding-left: 15px;
            .title{
                margin-top: 42px;
                padding: 4px 0 0;
                font-size: 13px;
                font-weight: 500;
                color: #333;
            }
            .num{
                font-size: 26px;
                font-weight: 500;
                color: #5470c6;
            }

            .img{
                // margin-top: 45px;
                margin-top: 52px;
                width: 90%;
                height: 80px;
            }
        }
    }

    .block3{
        display: flex;
        flex: 1;
        flex-direction: column;
        .block_head{
            display: flex;
            border-bottom:1px solid #eee;
            .head{
                // display: flex;
                // flex:2;
                // font-weight: bold;

                display: flex;
                flex: 2;
                flex-direction: column;
                font-weight: bold;
                font-size: 12px;
            }
        }

        .popover_search_btn{
            border-bottom:none;
        }

        .block_count_row{
            display:flex;
            // flex-direction: column;
            padding-left: 15px;
        }
    }

    

    .popover_search_btn{
        padding-bottom: 10px;
        border-bottom:1px solid #eee;

        /deep/ .arco-btn-text, .arco-btn-text[type='button'], 
        /deep/ .arco-btn-text[type='submit']{
            color: #666;
        }
    }

    
}

.popover_query{
    /deep/ .arco-picker-size-medium input,
    /deep/ .arco-form-item-label{
        font-size: 12px !important;
    }

    /deep/ .arco-form-item{
        margin-bottom: 5px;
    }   
}

button:focus, 
button:focus-visible {
    outline: none;
}

#chart{
    // display: flex;
    // flex:1;
    width: 100%;
    height: 300px;
}

// #chart2{
//     // display: flex;
//     // flex:1;
//     width: 35%;
//     height: 300px;
// }

// #chart3{
//     // display: flex;
//     // flex:1;
//     width: 35%;
//     height: 300px;
// }
</style>